import handleAddProductTbh from './HandleAddProductTbh';
import handleSubMenuClick from './HandleSubMenuClick';

export function handleRedirect(
  action,
  dispatch,
  setInputs,
  setProductTab,
  setCurrentPage,
  clickTriggeredRef
) {
  if (action === 'add-product') {
    dispatch({ type: 'mainPage', payload: 'product' });
    dispatch({ type: 'productCurrentPage', payload: { menu: 'product' } });
    dispatch({ type: 'phoneMenu', payload: 'params' });
    handleAddProductTbh(setInputs, setProductTab);
  } else if (action === 'configuration') {
    dispatch({ type: 'mainPage', payload: 'machine' });
    dispatch({ type: 'phoneMenu', payload: 'params' });
    handleSubMenuClick('Base machine', setCurrentPage, clickTriggeredRef);
  } else if (action === 'transport_direction') {
    dispatch({ type: 'mainPage', payload: 'machine' });
    dispatch({ type: 'phoneMenu', payload: 'params' });
    handleSubMenuClick('Flow', setCurrentPage, clickTriggeredRef);
  }
}
